/*
 * Module for the Withholding/_NewFederalForm view
*/

rs.module("ui/content/benefits/withholdings/withholding/newfederalform",

    [
        "common/visibility",
        "controls/components/event-banner"
    ],

    function (visibility, eventBanner) {

        // Initialize the module
        function initialize(
            jsSelectors,
            backendUrls,
            withholdingElections,
            withholdingKey,
            withholdingType,
            w4PChangeEffectiveDate,
            withholdingEffectiveDate,
            defaultEffectiveDate) {
            // Unpack js selectors
            var form = $.js(jsSelectors.form);
            var placeholderContent = $.js(jsSelectors.placeholderContent);
            var calculatedForm = $.js(jsSelectors.calculatedForm);

            var filingStatusRadioList = form.js(jsSelectors.filingStatusRadioList);
            var annualJobPayTextBox = form.js(jsSelectors.annualJobPayTextBox);
            var otherAnnualPensionTextBox = form.js(jsSelectors.otherAnnualPensionTextBox);
            var totalJobPensionIncomeTextBox = form.js(jsSelectors.totalJobPensionIncomeTextBox);
            var childDependentCreditTextBox = form.js(jsSelectors.childDependentCreditTextBox);
            var otherDependentCreditTextBox = form.js(jsSelectors.otherDependentCreditTextBox);
            var otherTaxCreditTextBox = form.js(jsSelectors.otherTaxCreditTextBox);
            var totalTaxCreditTextBox = form.js(jsSelectors.totalTaxCreditTextBox);
            var otherIncomeTextBox = form.js(jsSelectors.otherIncomeTextBox);
            var deductionsTextBox = form.js(jsSelectors.deductionsTextBox);
            var extraWithholdingNewFederalW4PTextBox = form.js(jsSelectors.extraWithholdingNewFederalW4PTextBox);
            var noWithholdingCheckBox = form.js(jsSelectors.noWithholdingCheckBox);
            var calculateButton = form.js(jsSelectors.calculateButton);
            var loadingSpinner = form.js(jsSelectors.loadingSpinner);
            var hiddenElection = form.js(jsSelectors.hiddenElection);
            var isPosted = form.js(jsSelectors.isPosted);

            /*
                Perform functions on page load.
                This includes replacing text instructions with the ones for that form year,
                registering inputs with their total textbox,
                and implementing the no withholding textbox change event.
            */

            // Update form text
            onLoad();

            // Register the no withholding checkbox change event
            noWithholdingCheckBox.change(onNoWithholdingCheckBoxChange);

            // Register calculate net benefit withholding button
            calculateButton.click(_.debounce(getCalculations, 300));

            // Various tasks to perform on load.
            function onLoad() {

                // Register total job pension income totals
                registerSumTextBoxes(totalJobPensionIncomeTextBox, annualJobPayTextBox, otherAnnualPensionTextBox);
                registerSumTextBoxes(totalTaxCreditTextBox, childDependentCreditTextBox, otherDependentCreditTextBox, otherTaxCreditTextBox);

                updatePlaceholdersForWithholdingYear();

                // Clear fields if the record was carried over from a record prior to the W4P Change Effective date.
                clearFields();
            }

            // Switch or replace the content of placeholders
            function updatePlaceholdersForWithholdingYear() {
                // Update form text with the year's form.
                setWithholdingText();

                replaceHtmlPlaceholders();

                // Destroy placeholder content.
                placeholderContent.remove();
            }

            // Switch content of placeholders with provided form data
            function setWithholdingText() {

                // Update selectors with the selected withholding form's text
                [
                    jsSelectors.step1cJointlyLabel,
                    jsSelectors.step1CautionRow,
                    jsSelectors.betweenSteps1And2Tip,
                    jsSelectors.steps2Through4Instructions,
                    jsSelectors.step2InstructionsLink,
                    jsSelectors.step2a,
                    jsSelectors.step2bi,
                    jsSelectors.step2bii,
                    jsSelectors.step2Tip,
                    jsSelectors.step2End,
                    jsSelectors.step3Instructions,
                    jsSelectors.step3a,
                    jsSelectors.stepResultNumber3a,
                    jsSelectors.step3b,
                    jsSelectors.stepResultNumber3b,
                    jsSelectors.step3c,
                    jsSelectors.stepResultNumber3c,
                    jsSelectors.step3TotalText,
                    jsSelectors.step4Name,
                    jsSelectors.step4bDeductionsText,
                    jsSelectors.noWithholdingText,
                ].forEach(function (selector) {

                    // Find the content in our form
                    var placeholder = placeholderContent.js(selector, { required: false });

                    // Replace content if found.
                    if (placeholder) {
                        form.js(selector).html(placeholder.html());
                    }
                });
            }

            // Instead of switching the content of the placeholder like in setWithholdingText,
            // completely replace the placeholder
            function replaceHtmlPlaceholders() {
                [
                    jsSelectors.applyCssForSpecificYears
                ].forEach(function (selector) {

                    // Find the content in our form
                    var placeholder = placeholderContent.js(selector, { required: false });

                    // Replace content if found.
                    if (placeholder) {
                        form.js(selector).replaceWith(placeholder.html());
                    }
                });
            }

            // Clears and disables
            function clearFields() {

                var isNewAndNotPosted = withholdingKey == -1 && isPosted.val() === "False";
                var isPreW4PChangeEffectiveDate = Date.parse(withholdingEffectiveDate) < Date.parse(w4PChangeEffectiveDate);
                if (isPreW4PChangeEffectiveDate || isNewAndNotPosted || noWithholdingCheckBox.is(":checked")) {
                    [
                        jsSelectors.annualJobPayTextBox,
                        jsSelectors.otherAnnualPensionTextBox,
                        jsSelectors.totalJobPensionIncomeTextBox,
                        jsSelectors.childDependentCreditTextBox,
                        jsSelectors.otherDependentCreditTextBox,
                        jsSelectors.otherTaxCreditTextBox,
                        jsSelectors.totalTaxCreditTextBox,
                        jsSelectors.otherIncomeTextBox,
                        jsSelectors.deductionsTextBox,
                        jsSelectors.extraWithholdingNewFederalW4PTextBox,
                    ].forEach(function (selector) {
                        form.js(selector).val('');
                    });

                    filingStatusRadioList.find("input").prop('checked', false);

                    // Only clear the no withholdings checkbox if it is pre-w4p change effective date.
                    if (isPreW4PChangeEffectiveDate) {
                        noWithholdingCheckBox.setChecked(false);
                    }
                }
            }

            // Link a total textbox with the child textboxes that sum into the total.
            function registerSumTextBoxes(totalTextBox, ...itemTextBoxes) {

                // Whenever a child textbox changes, update the total textbox.
                function updateTotal() {
                    const sum = itemTextBoxes.reduce((acc, input) => {

                        // removes everything but digits, dot, and minus sign
                        const cleaned = cleanInput(input);

                        const value = parseFloat(cleaned);
                        return acc + (isNaN(value) ? 0 : value);
                    }, 0);

                    // Format the sum as an accounting USD
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
                    const formatted = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        currencySign: "accounting"
                    }).format(sum);

                    totalTextBox.val(formatted);
                }

                itemTextBoxes.forEach(input => {
                    input.change(updateTotal);
                });

                // Initialize the total once at the start, if inputs are not blank.
                if (!totalTextBox.val() && itemTextBoxes.some(input => input != null && input.val().toString().trim() !== "")) {

                    updateTotal();
                }
            }

            // Handle the no withholding checkbox change event
            function onNoWithholdingCheckBoxChange() {

                // Get the value of the checkbox.
                var noWithholdingChecked = form.js(jsSelectors.noWithholdingCheckBox).is(':checked');

                // Conditionally enable all other inputs based on the no withholdings checkbox.
                filingStatusRadioList.find("input").prop('checked', false);
                filingStatusRadioList.find("input").prop('disabled', noWithholdingChecked);

                [
                    jsSelectors.annualJobPayTextBox,
                    jsSelectors.otherAnnualPensionTextBox,
                    jsSelectors.totalJobPensionIncomeTextBox,
                    jsSelectors.childDependentCreditTextBox,
                    jsSelectors.otherDependentCreditTextBox,
                    jsSelectors.otherTaxCreditTextBox,
                    jsSelectors.totalTaxCreditTextBox,
                    jsSelectors.otherIncomeTextBox,
                    jsSelectors.deductionsTextBox,
                    jsSelectors.extraWithholdingNewFederalW4PTextBox

                ].forEach(selector => form.js(selector).val('').clearErrors().prop('disabled', noWithholdingChecked));
            }

            // Function to calculate the new benefit withholding
            function getCalculations() {

                // Validate form before showing spinner and hiding fields
                var validator = form.validate();
                var isValid = validator.form();

                if (!isValid) {

                    // Scroll to view the first error.
                    validator.errorList[0].element.scrollIntoView({ behavior: "smooth", block: 'center' });

                    return;
                }

                // Remove messages and show spinner
                eventBanner.removeAllMessages();
                loadingSpinner.show();
                calculateButton.setDisabled(true);

                // Determine the election code to use.
                var withholdingElectionCd = null;
                if (noWithholdingCheckBox.is(":checked")) {
                    withholdingElectionCd = withholdingElections.noWithholding;
                }
                else {

                    if (extraWithholdingNewFederalW4PTextBox != null) {

                        // removes everything but digits, dot, and minus sign
                        const extraWithholdingVal = cleanInput(extraWithholdingNewFederalW4PTextBox);

                        if (extraWithholdingNewFederalW4PTextBox.val() && extraWithholdingVal > 0) {

                            withholdingElectionCd = withholdingElections.taxTablePlusExtra;
                        }
                        else {

                            withholdingElectionCd = withholdingElections.taxTable;
                        }
                    }
                }

                // Update the hidden election on calculating.
                hiddenElection.val(withholdingElectionCd);

                // Make call to backend.
                $.post(
                    backendUrls.calculateNetBenefitAsync,
                    {
                        withholdingKey: withholdingKey,
                        withholdingType: withholdingType,
                        withholdingElection: withholdingElectionCd,
                        effectiveDate: defaultEffectiveDate,

                        filingStatus: filingStatusRadioList.find('input:checked').val(),
                        state: null,
                        flatDollarAmount: 0,
                        percentOfTaxable: 0,
                        exemptions: 0,

                        extraWithholding: extraWithholdingNewFederalW4PTextBox.val(),
                        annualJobPay: annualJobPayTextBox.val(),
                        otherAnnualPension: otherAnnualPensionTextBox.val(),
                        totalJobPensionIncome: totalJobPensionIncomeTextBox.val(),
                        childDependentCredit: childDependentCreditTextBox.val(),
                        otherDependentCredit: otherDependentCreditTextBox.val(),
                        otherTaxCredit: otherTaxCreditTextBox.val(),
                        totalTaxCredit: totalTaxCreditTextBox.val(),
                        otherIncome: otherIncomeTextBox.val(),
                        deductions: deductionsTextBox.val(),
                    })
                    .done(function (calculatedHtml) {

                        calculatedForm.html(calculatedHtml);
                        visibility.hide(form);
                        visibility.show(calculatedForm);

                        var saveButton = calculatedForm.js(jsSelectors.saveButton);
                        var cancelButton = calculatedForm.js(jsSelectors.cancelButton);
                        var saveLoadingSpinner = calculatedForm.js(jsSelectors.saveLoadingSpinner);

                        // configure on click button
                        saveButton.on("click enterpressed", function () {
                            isPosted.val(true);
                            saveLoadingSpinner.show();
                            form.submit();
                        });

                        cancelButton.on("click enterpressed", function () {
                            visibility.hide(calculatedForm);
                            visibility.show(form);
                            calculatedForm.html(null);
                        });

                    })
                    .fail(function () {

                        // Scroll the window back to the top in the case of an error so that the error panel is in view.  
                        document.documentElement.scrollIntoView({ behavior: "smooth", block: 'center' });
                    })
                    .always(function () {

                        loadingSpinner.hide();
                        calculateButton.setDisabled(false);
                    });
            }

            // clean and parse input field.
            function cleanInput(input) {

                // Grab the value
                var rawValue = input.val();

                // Interpret accounting numbers as negative.
                // e.g. "(5)" is "-5"
                if (rawValue.startsWith('(') && rawValue.endsWith(')')) {
                    rawValue = "-" + rawValue.slice(1, -1);
                }

                // removes everything but digits, dot, and minus sign
                return rawValue.replace(/[^0-9.\-]/g, '');
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);